import React from "react";

const TrackingFake = () => {
  return (
    <section className="container">
      <div className="tracking-fake">
        <div className="tracking-fake--column-1">
          <div className="tracking-fake--column-1--card">
            <div className="skeleton tracking-fake--column-1--card--label" />
            <div className="skeleton tracking-fake--column-1--card--title" />
            <div className="skeleton tracking-fake--column-1--card--date" />
          </div>
        </div>
      </div>
      <style jsx>{`
        .tracking-fake {
          display: flex;
          flex-direction: column;
          margin: 1rem 0;
          &--column-1 {
            &--card {
              display: flex;
              flex-direction: column;
              align-items: start;
              width: 100%;
              padding: 1rem;
              border-radius: 1rem;
              border: 1px solid #dddddd;
              gap: 1rem;
              &--label {
                width: 20%;
                height: 18px;
              }
              &--title {
                width: 33%;
                height: 22px;
              }
              &--date {
                width: 70%;
                height: 16px;
              }
            }
          }
        }
        @media (min-width: 768px) {
          .tracking-fake {
            &--column-1 {
              width: 70%;
            }
          }
        }
      `}</style>
    </section>
  );
};

export default TrackingFake;
